const Style = {

  input: `float-left relative w-6 h-6 cursor-pointer mr-2 bg-none
  border border-solid border-sg-line bg-center appearance-none rounded-select
  checked:bg-[url('components/form/checkbox/icons/ico-check-white.svg')]
  checked:bg-sg-blue checked:border-sg-blue checked:bg-[length:10px] p-1`,
  label: 'cursor-pointer mt-px normal-case'

}

export default Style;